import { selectedRidersState } from '../../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice'
import { useSelector } from 'react-redux'

export default function NoRates() {

    const riders = useSelector(selectedRidersState)

    return (
        <div className='w-full col-span-1'>
            <p className='text-xs text-center p-2'>No rider/s selected</p>
        </div>
    )
}
